import { render, staticRenderFns } from "./AutocompleteObjects.vue?vue&type=template&id=2d79f705"
import script from "./AutocompleteObjects.vue?vue&type=script&lang=js"
export * from "./AutocompleteObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports